import React from 'react';
import { Link } from 'react-router';
import { Text } from '../../../design-system';
import styled from 'styled-components';
import InnerSideBar from './innerSideBar';

const UL = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const SelectedListItem = styled.li<{ selected?: any }>`
  padding: 25px 25px 25px 0;
`;

const ListItem = styled.li<{ selected?: any }>`
  padding: 15px 15px 15px 0;
`;

const StyledLink = styled(Link)`
  color: inherit;
  text-decoration: none;

  &:hover {
    color: ${(p) => p.theme.colors.grey};
  }
`;

interface SidebarProps {
  data: any[];
  selectedClient: any;
  innerSideBar: any;
}

const Sidebar = ({ data, selectedClient, innerSideBar }: SidebarProps) => {
  const selected = data.find(({ id }) => id === selectedClient.id) ?? null;
  return (
    <UL>
      {selected && (
        <SelectedListItem selected={selected}>
          <Text fontWeight={700}>{selected.fullName}</Text>
          <InnerSideBar {...innerSideBar} />
        </SelectedListItem>
      )}
      {data
        .filter((view) => selected !== view)
        .map(({ id, fullName }) => {
          return (
            <ListItem key={id} selected={selected}>
              <StyledLink to={`/vault/${id}/general-information`}>
                <Text fontSize={14}>{fullName}</Text>
              </StyledLink>
            </ListItem>
          );
        })}
    </UL>
  );
};

export default Sidebar;
